import Vue from 'vue';
import {USER_STATUSES, TICKET_STATUS} from '../components/devices/OperatorWorkspace/config';
import * as moment from "moment";

class TicketService {

  constructor() {
    this.ticketServicingTimerSub = null;
  }

  callTicket(id) {
    return new Promise((res, rej) => {
      if (Vue.prototype.$store.ticketTransactionEnd) {
        Vue.prototype.$store.ticketTransactionEnd = false;
        Vue.prototype.$crudService.post('ticket_servicing/', {window_id: Vue.prototype.$store.deviceStartData.window_id, ticket_id: id, self_redirect: true}).then((finalData) => {
          this.setCurrentTicket(finalData.data);
          this.clearAutoCallTimer();

          const waitingTime = Vue.prototype.$store.deviceStartData.unit_settings.delay_before_autocall;
          let autoCallTimer = moment().startOf('day')
            .seconds(waitingTime)
            .format('mm:ss');

          Vue.prototype.$store.autoCallTimer = autoCallTimer;
          Vue.prototype.$store.ticketTransactionEnd = true;
          res(finalData)
        }).catch((err) => rej(err))
      } else {
        rej('access')
      }
    });
  }

  closeTicket(ticketServicing) {
    return this.ticketFinalAction(`ticket_servicing/close/${ticketServicing.id}`, {
      end_type: TICKET_STATUS.CLOSED,
      tags: this.getCloseTags(Vue.prototype.$store.currentTicketTags)
    })
  }

  postponeTicket(ticketServicing) {
    return this.ticketFinalAction(`ticket_servicing/close/${ticketServicing.id}`, {
      end_type: TICKET_STATUS.POSTPONED,
      tags: this.getCloseTags(Vue.prototype.$store.currentTicketTags)
    })
  }

  absenceTicket(ticketServicing) {
    return this.ticketFinalAction(`ticket_servicing/close/${ticketServicing.id}`, {
      end_type: TICKET_STATUS.CANCELED,
      tags: this.getCloseTags(Vue.prototype.$store.currentTicketTags)
    })
  }

  orderAssembled(ticketServicing) {
    return this.ticketFinalAction(`ticket_servicing/close/${ticketServicing.id}`, {
      end_type: TICKET_STATUS.READIED,
      tags: this.getCloseTags(Vue.prototype.$store.currentTicketTags)
    })
  }

  orderIssued(ticket) {
    return Vue.prototype.$crudService.post(`tickets/close_ready/${ticket.id}`);
  }

  backToAliveTicket(ticket_id, window_id, service_id) {
    return Vue.prototype.$crudService.post('ticket_servicing/back-to-alive', {
      ticket_id,
      window_id: Vue.prototype.$store.deviceStartData.window_id,
      redirect_to_office_service_id: service_id,
      redirect_to_window_id: window_id
    })
  }

  reCallTicket(id) {
    this.startRecallTimer();
    return Vue.prototype.$crudService.put(`ticket_servicing/call/${id}`);
  }

  ticketFinalAction(link, params) {
    return new Promise((res, rej) => {
      if (Vue.prototype.$store.ticketTransactionEnd) {
        Vue.prototype.$store.ticketTransactionEnd = false;
        Vue.prototype.$crudService.put(link, params).then((data) => {
          this.clearCurrentTicket();
          res(data)
        }).catch((err) => rej(err))
      }
    });
  }

  setCurrentTicket(ticketServicing) {
    Vue.prototype.$store.currentTicketServicing = ticketServicing;
    Vue.prototype.$store.currentTicket = Vue.prototype.$store.unsortedTickets.find(ticket => ticket.id === Vue.prototype.$store.currentTicketServicing.ticket_id);
    Vue.prototype.$store.currentTicketTags = [];

    const service = this.getCurrentService(Vue.prototype.$store.currentTicketServicing.office_service_id);

    this.startTicketTimer((service.time_limit * 60) * 2)
  }

  clearCurrentTicket() {
    this.clearTicketTimer();
    this.startAutoCallTimer();
    Vue.prototype.$store.currentTicket = null;
    Vue.prototype.$store.currentTicketServicing = null;
    Vue.prototype.$store.currentTicketTags = [];
    Vue.prototype.$statusService.writeStatus(USER_STATUSES.IDLE);
  }

  redirect(ticketServicingId, serviceId, windowId, defaultServiceId, tags = []) {
    const params = {
      tags,
      redirect_to_office_service_id: serviceId ? serviceId : defaultServiceId,
      redirect_to_window_id: windowId
    };

    return Vue.prototype.$crudService.put(`ticket_servicing/redirect/${ticketServicingId}`, params).then(() => {
      this.clearCurrentTicket();
    })
  }

  getLastAction(ticket) {
    if (ticket.ticket_servicing_list && ticket.ticket_servicing_list.length) {
      const lastTicketServicing = ticket.ticket_servicing_list[ticket.ticket_servicing_list.length - 1];

      if (lastTicketServicing && lastTicketServicing.end_type) {
        return {
          status: lastTicketServicing.end_type,
          user: lastTicketServicing.user
        }
      }
    }

    return false;
  }

  getCurrentLastAction(ticket) {
    if (ticket.ticket_servicing_list && ticket.ticket_servicing_list.length) {
      let lastTicketServicing = ticket.ticket_servicing_list.length >= 2 ?
        ticket.ticket_servicing_list[ticket.ticket_servicing_list.length - 2] :
        ticket.ticket_servicing_list[ticket.ticket_servicing_list.length - 1];

      if (lastTicketServicing && lastTicketServicing.end_type) {
        return {
          status: lastTicketServicing.end_type,
          user: lastTicketServicing.user
        }
      }
    }

    return false;
  }

  startTicketTimer(time) {
    this.clearTicketTimer();
    Vue.prototype.$store.aliveModalTimer = setTimeout(() => {
      Vue.prototype.$modal.show(Vue.prototype.$MODAL_NAME.ALIVE)
    }, time * 1000)
  }

  clearTicketTimer() {
    clearTimeout(Vue.prototype.$store.aliveModalTimer);
  }

  startRecallTimer() {
    this.clearRecallTimer();
    Vue.prototype.$store.ticketRecallAccess = false;
    Vue.prototype.$store.ticketRecallTimer = setTimeout(() => {
      Vue.prototype.$store.ticketRecallAccess = true;
    }, 3000)
  }

  clearRecallTimer() {
    clearTimeout(Vue.prototype.$store.ticketRecallTimer);
  }

  startAutoCallTimer() {
    if (Vue.prototype.$store.deviceStartData.unit_settings.automatic_call_of_ticket) {
      this.clearAutoCallTimer();
      const autoCallWaitingTime = Vue.prototype.$store.deviceStartData.unit_settings.delay_before_autocall;
      const eventTime = moment().add(autoCallWaitingTime, 'seconds');

      this.ticketServicingTimerSub = Vue.prototype.$eventEmitter.subscribe(Vue.prototype.$eventEmitter.eventTypes.TIME_TICK, () => {
        const finalSeconds = eventTime.diff(moment(), 'seconds');
        const autoCallTimer = moment().startOf('day')
          .seconds(finalSeconds)
          .format('mm:ss');

        if (finalSeconds <= 0) {
          if (this.ticketServicingTimerSub) {
            this.ticketServicingTimerSub()
          }

          Vue.prototype.$eventEmitter.emit(Vue.prototype.$eventEmitter.eventTypes.AUTOCALL_CALL);
        }

        Vue.prototype.$store.autoCallTimer = autoCallTimer;
      })
    }
  }

  clearAutoCallTimer() {
    if (this.ticketServicingTimerSub) {
      this.ticketServicingTimerSub()
    }
  }

  getCloseTags(tags) {
    return tags.length ? tags.map(tag => tag.id) : [0]
  }

  getCurrentService(id) {
    let currentService;

    const recursiveSearch = (tree) => {
      tree.forEach(treeItem => {
        if (treeItem.hasOwnProperty('child') && treeItem.child.length) {
          recursiveSearch(treeItem.child)
        } else {
          if (treeItem.id === id) {
            currentService = treeItem;
          }
        }
      })
    };

    recursiveSearch(Vue.prototype.$store.deviceStartData.services_tree);

    return currentService ? currentService.service : null;
  }

  getServiceTitle(service) {
    return service.name[Vue.prototype.$store.activeLanguage] ? service.name[Vue.prototype.$store.activeLanguage] : Object.values(service.name).find(val => val)
  }
}

export default TicketService;
